export function setupFooter() {
  let siteFooterContent = document.querySelector("#footer-left");
  siteFooterContent.innerHTML = `
      <p>
        <a class="apache-link" href="https://airflow.apache.org/"
          >Apache Airflow</a
        >, Airflow, and the Airflow logo are trademarks of the <a
          class="apache-link"
          href="https://apache.org/">Apache Software Foundation</a
        >. Copyright &copy; Astronomer 2023. All rights
        reserved.
      </p>
`;
}